export enum SurveyVariableConditionSectionTypeEnum {
  Free = 'free',
  Product = 'product',
  Worker = 'worker',
  ProductByWorker = 'product_by_worker',
  Skills = 'skills',
}
